import apiClient from "./apiClient";
import { Country, CountrySettings } from "../types/countryTypes";

/**
 * Devuelve los países a los que tiene acceso el usuario autenticado.
 * El backend resuelve el usuario a partir del token (GET /countries/me).
 */
export const getMyCountries = async (): Promise<Country[]> => {
  try {
    const response = await apiClient.get("/countries/me");
    return response.data || [];
  } catch (error) {
    console.error("Error al obtener los países del usuario:", error);
    return [];
  }
};

/** Lista de países activos (para pantallas de administración). */
export const getActiveCountries = async (): Promise<Country[]> => {
  const response = await apiClient.get("/countries/active");
  return response.data || [];
};

/** Todos los países (activos e inactivos) para administración. */
export const getAllCountries = async (): Promise<Country[]> => {
  const response = await apiClient.get("/countries");
  return response.data || [];
};

export const createCountry = async (country: Partial<Country>): Promise<Country> => {
  const response = await apiClient.post("/countries", country);
  return response.data;
};

export const updateCountry = async (id: number, country: Partial<Country>): Promise<Country> => {
  const response = await apiClient.put(`/countries/${id}`, country);
  return response.data;
};

/** Baja lógica del país. */
export const deleteCountry = async (id: number): Promise<void> => {
  await apiClient.delete(`/countries/${id}`);
};

export const getCountrySettings = async (id: number): Promise<CountrySettings> => {
  const response = await apiClient.get(`/countries/${id}/settings`);
  return response.data;
};

export const updateCountrySettings = async (
  id: number,
  settings: Partial<CountrySettings>
): Promise<CountrySettings> => {
  const response = await apiClient.put(`/countries/${id}/settings`, settings);
  return response.data;
};

/** Países asignados a un usuario. */
export const getUserCountries = async (rut: string): Promise<Country[]> => {
  const response = await apiClient.get(`/usersCountries/${rut}`);
  return response.data || [];
};

/** Reemplaza el conjunto de países asignados a un usuario. */
export const updateUserCountries = async (rut: string, countries: number[]): Promise<void> => {
  await apiClient.put("/usersCountries/update", { rut, countries });
};
